export class MergeRoutingRouteNames {
    public static readonly Choose = 'choose';
    public static readonly Select = 'select';
}
